import React from "react";
import "./HousekeepingHero.css";

import { Link } from "react-router-dom";
import Navbar from "../../Header/Navbar";

const InvestmentHero = () => {
  return (
    <>
      <Navbar />

      {/* HERO SECTION */}
      <section className="hk-mini-hero">
        <div className="hk-mini-container">
          {/* Main Title */}
          <h1 className="hk-mini-title">
            Investment Advisory
          </h1>

          {/* Breadcrumb */}
          <p className="hk-mini-breadcrumb">
            <Link to="/" className="hk-mini-link">Home</Link>
            <span>-</span>
            <Link to="/services" className="hk-mini-link">Our Services</Link>
            <span>-</span>
            <Link to="/investment-advisory" className="hk-mini-link">
              Investment Advisory
            </Link>
          </p>
        </div>
      </section>

      {/* TAG BELOW HERO */}
     
    </>
  );
};

export default InvestmentHero;
